module.exports = __webpack_public_path__ + "p3_img1.jpg?2e1c03fecd4cb995974d26eb1cfe654f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p3/p3_img1.jpg
// module id = 117
// module chunks = 0